import { Close } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import { CONTRACTS_MODAL_STYLES } from "../../styles/styles";

export default function ContractsTextField({ fieldName, fieldValue, onChange }) {
  const { inputMode, pattern, validator } = arguments[0];

  return (
    <TextField
      className="w-full"
      size="small"
      value={fieldValue}
      onChange={(event) => {
        const nextValue = event.target.value;

        if (pattern && !pattern.test(nextValue)) {
          return;
        }

        if (validator && !validator(nextValue)) {
          return;
        }

        onChange(fieldName, nextValue);
      }}
      sx={CONTRACTS_MODAL_STYLES.textField}
      inputProps={{ inputMode }}
      InputProps={{
        endAdornment: fieldValue ? (
          <InputAdornment position="end" className="p-2">
            <IconButton onClick={() => onChange(fieldName, "")} edge="end" size="small">
              <Close fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
}
